import { render } from "./TelexComponent.vue?vue&type=template&id=57ca338c&scoped=true"
import script from "./TelexComponent.vue?vue&type=script&lang=js"
export * from "./TelexComponent.vue?vue&type=script&lang=js"

import "./TelexComponent.vue?vue&type=style&index=0&id=57ca338c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57ca338c"]])

export default __exports__